
<ng-template [ngIf]="isLoadingStoricoListino">
      <app-loading></app-loading>
</ng-template>
<div fxFlex="95%" class="mt-2">
  <p-table #listiniDT styleClass="p-datatable-striped" [value]="storicoListino" dataKey="id" 
  [loading]="isLoadingStoricoListino"
   >

  <ng-template pTemplate="header" >
      <tr >
        <th class="text-center" style="font-size: 14px;">
          DATA MODIFICA
        </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.1
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.2
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.3
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.4
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.5
          </th>
          <th class="text-center" style="font-size: 14px;">
            PREVENTIVO BASE
          </th>
         
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td class="text-center"> <span class="text-uppercase font-bold" style="font-weight: 500; ">{{utilService.formattaDataDaDate(row.creato)}}</span> </td>
      
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.liguria1}} €</span> </td>
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.liguria2}} €</span> </td>
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.liguria3}} €</span> </td>
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.liguria4}} €</span> </td>
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.liguria5}} €</span> </td>
      <td *ngIf="regione==='LIGURIA'" class="text-center"> <span class="text-uppercase font-semibold" style="font-weight: 500; ">{{row.preventivoBaseLiguria}} €</span> </td>
     
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.piemonte1}} €</span> </td>
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.piemonte2}} €</span> </td>
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.piemonte3}} €</span> </td>
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.piemonte4}} €</span> </td>
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.piemonte5}} €</span> </td>
      <td *ngIf="regione==='PIEMONTE'" class="text-center"> <span class="text-uppercase font-semibold" style="font-weight: 500; ">{{row.preventivoBasePiemonte}} €</span> </td>
      
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna1}} €</span> </td>
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna2}} €</span> </td>
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna3}} €</span> </td>
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna4}} €</span> </td>
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna5}} €</span> </td>
      <td *ngIf="regione==='SARDEGNA'" class="text-center"> <span class="text-uppercase font-semibold" style="font-weight: 500; ">{{row.preventivoBaseSardegna}} €</span> </td>
     

    </tr>
  </ng-template>
  
  </p-table>
    <!-- 
    <p-timeline [value]="storicoNazionale" class="align-items-right justify-content-right">
      <ng-template pTemplate="marker" let-nazionale>
        <span
            class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1 material-symbols-outlined small-icon"
            [ngClass]="stiliService.getMaterialIconStoricoListino(nazionale)"
            [style]="{ 'background-color': stiliService.getColoreIconaStoricoListino(nazionale) }"
            >
            {{ stiliService.getMaterialIconStoricoListino(nazionale)}}
        </span>
    </ng-template>
      <ng-template pTemplate="content" let-nazionale>
          <span class="font-['Poppins']; font-semibold" style="font-size: 11px;"  >SCL1: {{nazionale.scl1}} </span>
          <span class="font-['Poppins']; font-semibold" style="font-size: 11px;"  >SCL2: {{nazionale.scl2}} </span>
          <span class="font-['Poppins']; font-semibold" style="font-size: 11px;"  >SCL3: {{nazionale.scl3}} </span>
          <span class="font-['Poppins']; font-semibold" style="font-size: 11px;"  >SCL4: {{nazionale.scl4}} </span>
          <span class="font-['Poppins']; font-semibold" style="font-size: 11px;"  >SCL5: {{nazionale.scl5}}</span>
      </ng-template>
      <ng-template pTemplate="opposite" let-nazionale>
        <span class="font-['Poppins'] mt-3"  style="font-weight: bold;">{{formatDate(nazionale.eliminato)}}</span>
      </ng-template>
    </p-timeline> -->
    <div class="border-top-1 surface-border mt-5" style="text-align: center;">
      <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-6 mt-3"></button>
    </div>
    
    <div>
    